module.exports = __webpack_public_path__ + "src/assets/models_low/petri/petri_red.fbx";